import { AvatarImage } from '@radix-ui/react-avatar';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { Link } from 'react-router';

import { Badge } from '@/components/deprecated/Badge';
import { Avatar } from '@/components/ui/avatar';
import { Skeleton } from '@/components/ui/skeleton';
import { MEDIA_URL } from '@/config';

import { fetchTeamRoster } from '../api/getTeamRoster';
import { getPlayerRoles } from '../utils';

interface TeamMembersProps {
  teamId: string;
}
const TeamMembers: React.FC<TeamMembersProps> = ({ teamId }) => {
  const { data: roster, isLoading } = useQuery({
    queryKey: ['roster', teamId],
    queryFn: () => fetchTeamRoster(teamId),
  });

  return (
    <div>
      <div className="mb-3 text-lg font-semibold">Team Members</div>
      <div className="grid grid-cols-2 gap-x-8 gap-y-4 rounded-xl border border-border px-4 py-3 lg:grid-cols-3">
        {isLoading || !roster ? (
          <>
            {Array.from({ length: 6 }, (_, index) => (
              <div
                className="flex flex-col items-center gap-1.5 rounded-md px-3 py-4 sm:flex-row sm:gap-3"
                key={index}
              >
                <Skeleton className="h-[88px] w-[88px] rounded-md" />
                <div className="flex flex-col p-1">
                  <Skeleton className="mb-3 h-2.5 w-28" />
                  <Skeleton className="h-2.5 w-16" />
                </div>
              </div>
            ))}
          </>
        ) : (
          <>
            {roster.map((player) => (
              <Link
                className="hover:bg-block flex cursor-pointer flex-col items-center gap-1.5 rounded-md px-3 py-4 transition-colors sm:flex-row sm:gap-3"
                key={player.steamid}
                to={`/profile/${player.id}`}
                title={`Go to ${player.username}'s profile`}
              >
                <Avatar className="h-[88px] w-[88px] !rounded-md">
                  <AvatarImage
                    src={`${
                      player.profile_photo?.includes('https')
                        ? player.profile_photo
                        : `${MEDIA_URL}/${player.profile_photo}`
                    }`}
                    alt={player.username}
                    className="!rounded-md"
                  />
                </Avatar>
                <div className="flex flex-col p-1">
                  <h2 className="text-semibold font-medium">
                    {player.username}
                  </h2>
                  <span className="mb-3 text-xs text-muted-foreground">
                    {getPlayerRoles(player).join(', ') || 'Player'}
                  </span>
                  {player.league_roster && (
                    <Badge size="sm" className="self-start whitespace-nowrap">
                      League roster
                    </Badge>
                  )}
                </div>
              </Link>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export { TeamMembers };
